<template>
    <TeamTabs :selected-team="selectedTeam" tab-key="team-activity-logs">
        <ActivityLogRangePanel
            :title="`${selectedTeam.name} — ${t('vue.kiosk_activity_logs')}`"
            :description="t('vue.kiosk_activity_logs_team_description')"
            :from="from"
            :to="to"
            :page="page"
            :per-page="perPage"
            :total="total"
            :logs="logs"
            :filters="filters"
            :filter-options="filterOptions"
            route-name="kiosk.teams.activity-logs.index"
            :route-params="{ team: selectedTeam.id }"
        />
    </TeamTabs>
</template>

<script lang="ts" setup>
import type ICurrentTeam from "@/types/Members/ICurrentTeam";
import { useTranslations } from "@/composables/useTranslations";
import ActivityLogRangePanel from "../../ActivityLogs/components/ActivityLogRangePanel.vue";
import type {
    IActivityLogFilterOptions,
    IActivityLogFilters,
    IActivityLogItem,
} from "../../ActivityLogs/types";

defineProps<{
    selectedTeam: ICurrentTeam;
    from: string;
    to: string;
    page: number;
    perPage: number;
    total: number;
    logs: IActivityLogItem[];
    filters: IActivityLogFilters;
    filterOptions: IActivityLogFilterOptions;
}>();

const { t } = useTranslations();
</script>
